import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

// Example SEO position data
const data = [
  { day: "Lun", position: 60 },
  { day: "Mar", position: 55 },
  { day: "Mer", position: 50 },
  { day: "Jeu", position: 48 },
  { day: "Ven", position: 45 },
];

export default function StatsChart() {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <Line
          type="monotone"
          dataKey="position"
          stroke="#3b82f6"
          strokeWidth={2}
          dot={{ r: 3 }}
          isAnimationActive
        />
        <XAxis dataKey="day" stroke="#6b7280" />
        <YAxis stroke="#6b7280" reversed />
        <Tooltip />
      </LineChart>
    </ResponsiveContainer>
  );
}
